<template>
  <div>
    <a-modal
      @ok="ok"
      class="tip"
      :title="title"
      @cancel="cancel"
      :okText="okText"
      :visible="visible"
      :class="className"
      :cancelText="cancelText"
      :maskClosable="maskClosable"
    >
      <div v-if="desc" v-html="desc" />
      <!-- <a-radio-group @change="handleChange" v-model="checked" class="radioGroup" >
        <a-radio v-for="item in options" :key="item.id" :value="item.id">{{ item.name }}</a-radio>
      </a-radio-group> -->
      <div class="login-out" v-if="!loginButton">
        <a-button @click="backLogin"> 退出登录 </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import cookie from 'js-cookie'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    checked: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    loginButton: {
      type: Boolean,
      default: true
    },
    className: {
      type: Array,
      default: () => []
    }
    // options: {
    //   type: Array,
    //   default: () => []
    // }
  },
  methods: {
    ok() {
      this.$emit('ok')
    },
    handleChange() {
      this.$emit('ok', this.checked)
    },
    cancel() {
      this.$emit('cancel')
    },
    backLogin() {
      this.$emit('cancel')
      cookie.remove(ACCESS_TOKEN)
      cookie.remove(ACCESS_TOKEN, {
        domain: '.' + location.hostname
      })
      cookie.remove('user_type')
      cookie.remove('user_type', {
        domain: '.' + location.hostname
      })
      cookie.remove('user_infor')
      cookie.remove('user_infor', {
        domain: '.' + location.hostname
      })
      window.location.reload()
    }
  }
}
</script>

<style lang="less" scoped>
.tip {
  /deep/.ant-modal {
    top: 30%;
    padding-bottom: 0;
    width: 320px !important;
    .ant-modal-content {
      background: url('./../../assets/img/bj_ts.png');
      background-size: 100% 100%;
      background-position: center;
    }
    .ant-modal-header {
      background: none;
      border-bottom: 0;
      .ant-modal-title {
        font-size: 16px;
        font-weight: 800;
        color: #000000;
        line-height: 22px;
      }
    }
    .ant-modal-body {
      display: flex;
      font-size: 16px;
      font-weight: 800;
      color: #000000;
      line-height: 22px;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      padding: 28px 22px 0;
      p {
        font-size: 16px;
        font-weight: 800;
        color: #000000;
        line-height: 26px;
        margin-bottom: 9px;
        text-align: center;
        &:last-child {
          margin-bottom: 22px;
        }
      }
      .placeholder {
        font-size: 14px;
        font-weight: 400;
        color: #596777;
        line-height: 20px;
        margin-top: 12px;
      }
      .text {
        font-size: 14px;
        font-weight: 400;
        color: #2c3b4d;
      }
      .text-left {
        text-align: left;
        display: flex;
        flex-direction: column;
        .title {
          display: flex;
          align-items: center;
          .icon {
            width: 19px;
            height: 15px;
            margin-right: 7px;
          }
        }
        .text {
          padding-left: 26px;
          display: inline-block;
        }
        &:last-child {
          margin-bottom: 0 !important;
        }
      }
      .noPermission {
        width: 133px;
      }
      .login-out {
        width: 100%;
        display: flex;
        margin-top: -20px;
        position: relative;
        justify-content: center;
        .ant-btn {
          width: 84px;
          height: 30px;
          font-size: 14px;
          font-weight: 500;
          color: #8c8c8c;
          line-height: 20px;
          border-radius: 15px;
          border: 1px solid #dcdcdc;
        }
      }
    }
    .ant-modal-close-x {
      opacity: 0;
    }
    .ant-modal-footer {
      display: flex;
      border-top: 0;
      padding: 0 0 22px;
      justify-content: center;
      .ant-btn,
      .ant-btn:hover {
        border: 0;
        min-width: 94px;
        height: 35px;
        color: #9b1205;
        border-radius: 6px;
        background: #fcf3ec;
        box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
      }
      .ant-btn.ant-btn-primary,
      .ant-btn.ant-btn-primary:hover {
        border: 0;
        width: auto;
        height: 35px;
        color: #fff;
        margin-left: 24px;
        background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%);
        box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
        border-radius: 6px;
      }
    }
  }
}
.tip.about {
  /deep/.ant-modal {
    .ant-modal-content {
      background: url('./../../assets/img/bj_gy.png');
      background-size: 100% 100%;
      background-position: center;
    }
  }
}
.tip.optionModal {
  /deep/.ant-modal {
    width: 281px !important;
    .radioGroup.ant-radio-group {
      display: flex;
      margin-bottom: 30px;
      justify-content: center;
      .ant-radio-wrapper {
        padding: 0;
        width: 90px;
        height: 35px;
        display: flex;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        align-items: center;
        justify-content: center;
      }
    }
    .ant-modal-close-x {
      opacity: 1;
    }
    .ant-modal-body {
      padding: 15px 34px 0;
    }
    .ant-modal-footer {
      display: none;
    }
  }
}
.tip.nocancel {
  /deep/.ant-modal {
    width: 320px !important;
    .ant-modal-close-x {
      opacity: 0;
    }
    .ant-modal-body {
      padding: 15px 34px 0;
    }
    .ant-modal-footer .ant-btn {
      margin-left: 0;
      &:first-child {
        display: none;
      }
      &:hover {
        margin-left: 0;
      }
    }
  }
}
.tip.noOk.nocancel {
  /deep/.ant-modal {
    .ant-modal-body {
      padding: 35px 0;
      .text.text-left {
        margin-bottom: 17px;
      }
      .text.text-left:last-child {
        margin-bottom: 0;
      }
    }
    .ant-modal-footer {
      display: none;
    }
  }
}
.tip.ant-modal-root.nocancel.langButton.nocancel {
  /deep/.ant-btn.ant-btn-primary {
    width: 177px;
  }
}
.tip.noPermission {
  /deep/.ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.85);
  }
}
</style>
